import type React from 'react';

import { Separator } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { Circle, Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { circleSizes, rectangleShapes } from './header.constants';
import { HeaderStyles, NotchStyles, SeparatorStyles, SubredditInfoStyles } from './Header.styles';
import type { LoadingComponentsProps } from './types';

const gaps = {
	small: 'gap-0.5',
	medium: 'gap-1.5',
	large: 'gap-1.5',
};

export const HeaderLoading: React.FC<LoadingComponentsProps> = ({ size, retryState }) => {
	// Disable animation when in failed retry state (static background for better contrast)
	const shouldAnimate = retryState !== 'failed';

	if (size === 'xsmall') {
		return (
			<SkeletonContainer className="h-full w-full" loading={shouldAnimate} data-testid="header-loading-root">
				<Rectangle className="h-full w-full" />
			</SkeletonContainer>
		);
	}

	return (
		<>
			<SkeletonContainer className={HeaderStyles({ size })} loading={shouldAnimate} data-testid="header-loading-root">
				<Rectangle className={cn(NotchStyles({ size }), 'bg-icon-inverse-disabled')} />
				<div className={SubredditInfoStyles({ size })}>
					<Circle className={circleSizes[size]} />
					<div className={cn('flex flex-col', gaps[size])}>
						{rectangleShapes.map((rect) => (
							<Rectangle key={rect.key} className={rect.sizes[size]} rounded />
						))}
					</div>
				</div>
			</SkeletonContainer>
			<Separator className={SeparatorStyles({ size })} data-testid="header-loading-separator" />
		</>
	);
};
